import React from "react";
import OperationalDocumentEditor from "../common/OperationalDocumentEditor";
import { CashDocForm } from "./Form";

export function CashDocCreate() {
  return <OperationalDocumentEditor create kind="cash" FormComponent={CashDocForm} />;
}
